import { AxiosResponse } from 'axios'
import { BaseAPI } from './BaseAPI.js'
import { AlertsResponse, Organization } from '../types/index.js'

export default class OrganizationsAPI extends BaseAPI<Organization> {
  override get resource(): string {
    return '/organizations'
  }

  public async alerts(
    organizationId: number | string,
  ): Promise<AlertsResponse> {
    const result: AxiosResponse = await this._client.get(
      `organizations/${organizationId}/alerts`,
    )

    return result.data.data
  }

  public async payment(
    organizationId: number,
    amount: number,
  ): Promise<{ attributes: { redirectUrl: string } }> {
    const result: AxiosResponse = await this._client.post(
      `organizations/${organizationId}/payments`,
      {
        data: {
          type: 'payments',
          attributes: {
            amount,
          },
        },
      },
    )

    return result.data.data
  }
}
